import React from 'react';
// Delivered orders management
export function getDeliveredOrders() {
  try {
    const orders = JSON.parse(localStorage.getItem('deliveredOrders'));
    if (Array.isArray(orders)) return orders;
    return [];
  } catch {
    return [];
  }
}

export function addDeliveredOrder(order) {
  const orders = getDeliveredOrders();
  if (!orders.find(o => o.orderId === order.orderId)) {
    orders.push(order);
    localStorage.setItem('deliveredOrders', JSON.stringify(orders));
  }
}

export function getCurrentOrders() {
  // Get all current orders from localStorage (array of order objects)
  try {
    const orders = JSON.parse(localStorage.getItem('currentOrders'));
    if (Array.isArray(orders)) return orders;
    return [];
  } catch {
    return [];
  }
}

export function addCurrentOrder(order) {
  // Add a new order to localStorage (if not already present)
  const orders = getCurrentOrders();
  if (!orders.find(o => o.orderId === order.orderId)) {
    orders.push(order);
    localStorage.setItem('currentOrders', JSON.stringify(orders));
  }
}

export function removeCurrentOrder(orderId) {
  // Remove an order from localStorage by orderId
  const orders = getCurrentOrders().filter(o => o.orderId !== orderId);
  localStorage.setItem('currentOrders', JSON.stringify(orders));
}

export default {
  getCurrentOrders,
  addCurrentOrder,
  removeCurrentOrder,
};
